import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { SiaSessionService } from './session.service';

@Injectable({
  providedIn: 'root',
})
export class SiaSubtitleService {
  private sessionService = inject(SiaSessionService);

  private _titleChange: Subject<string> = new Subject();
  private _subtitleChange: Subject<string> = new Subject();
  private _subtitleInformationChange: Subject<string> = new Subject();

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  titleChanged$() {
    return this._titleChange.asObservable();
  }

  subtitleChanged$() {
    return this._subtitleChange.asObservable();
  }

  subtitleInformationChanged$() {
    return this._subtitleInformationChange.asObservable();
  }

  getSubTitleAdditionalInformation(guid: string) {
    return this.sessionService.getTitleAdditionalInformation(guid);
  }

  getTitle(guid: string) {
    return this.sessionService.getTitle(guid);
  }

  getSubtitle(guid: string) {
    return this.sessionService.getSubtitle(guid);
  }

  setSubTitleAdditionalInformation(guid: string, subtitleInformation: string) {
    this.sessionService.setTitleAdditionalInformation(guid, subtitleInformation);
    this._subtitleInformationChange.next(guid);
  }
  setSubtitle(guid: string, subtitle: string) {
    this.sessionService.setSubtitle(guid, subtitle);
    this._subtitleChange.next(guid);
  }

  setTitle(guid: string, title: string) {
    this.sessionService.setTitle(guid, title);
    this._titleChange.next(guid);
  }
}
